<template>
  <div v-show="visible" class="zp-table1" :style="style">
    <div class="zp-table1-box" v-show="showContent ==='0830'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">西北工业大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0902'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">哈尔滨工业大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0903'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">哈尔滨工程大学</a>
      </div>
    </div>
    <div class="zp-table1-doubleBox" v-show="showContent ==='0904'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">东北大学</a>
      </div>
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">大连理工大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0905'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">吉林大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0906'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">天津大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0909'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">山东大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0910'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">浙江大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0911'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">中国科学技术大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0912'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">华中科技大学</a>
      </div>
    </div>
    <div class="zp-table1-doubleBox" v-show="showContent ==='0913'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">四川大学</a>
      </div>
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">电子科技大学</a>
      </div>
    </div>
    <div class="zp-table1-doubleBox" v-show="showContent ==='0918'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">西安电子科技大学</a>
      </div>
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">西安交通大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0919'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">兰州大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0923'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">上海交通大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0924'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">复旦大学</a>
      </div>
    </div>
    <div class="zp-table1-doubleBox" v-show="showContent ==='0925'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">清华大学</a>
      </div>
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">北京理工大学</a>
      </div>
    </div>
    <div class="zp-table1-doubleBox" v-show="showContent ==='0926'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">北京航空航天大学</a>
      </div>
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">北京大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='0929'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">重庆大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='1008'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">中南大学</a>
      </div>
    </div>
    <div class="zp-table1-box" v-show="showContent ==='1009'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">国防科技大学</a>
      </div>
    </div>
    <div class="zp-table1-doubleBox" v-show="showContent ==='1010'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">南京航空航天大学</a>
      </div>
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">东南大学</a>
      </div>
    </div>
    <div class="zp-table1-doubleBox" v-show="showContent ==='1011'">
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">南京理工大学</a>
      </div>
      <div class="zp-table1-info">
        <a class="zp-table1-contentInfo">南京大学</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "showDialog",
  data() {
    return {
      visible: true,
      x:-9999,
      y:-9999,
      showContent:"",
    };
  },
  computed:{
    style() {
      return {
        top:`${this.x}px`,
        left:`${this.y }px`
        // top:`${this.y-104}px`,
        // left:`${this.x-756}px`
      }
    }
  },
  methods: {
    open(date) {
      this.x = 17
      this.y = -40
      if(date==="0929"){
        this.x = 17
        this.y = -40
      }
      if(date==="0902"||date==="0909"||date==="0923"){
        this.x = 17
        this.y = -25
      }
      if(date==="1008"||date==="1009"){
        this.x = -50
        this.y = -25
      }
      if(date==="1010"||date==="1011"){
        this.x = -90
        this.y = -25
      }
      this.showContent=date
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.zp-table1 {
  //position: fixed;
  position: absolute;
  z-index: 2;

  &-doubleBox {
    width: 130px;
    height: 40px;
    margin-top: 20px;
    box-shadow: 0px 3px 8px rgba(0,0,0,0.2);
    //text-align: center;
    //outline: 0.1px solid #c7d2f2;
  }
  &-box {
    width: 130px;
    height: 40px;
    margin-top: 20px;
    //text-align: center;
    outline: 0.1px solid #c7d2f2;
    box-shadow: 0px 3px 8px rgba(0,0,0,0.2);
  }
  &-info {
    height: 100%;
    background-color: #dce5ff;
    display: flex;
    justify-content: center;
  }
  &-contentInfo {
    color: #000000;
    margin-top: 10px;
  }
  //&-column {
  //  width: 100px;
  //  color: #1f62c5;
  //  outline: 0.1px solid #c7d2f2;
  //}
  //&-column1 {
  //  width: 100px;
  //  color: #333333;
  //  outline: 0.1px solid #c7d2f2;
  //}

  //left: 200px;
  //right: 200px;
  //top: 200px;
  //bottom: 200px;
  //width: 200px;

  //&-doubleBox {
  //  width: 160px;
  //  height: 100%;
  //  text-align: left;
  //  outline: 0.1px solid #c7d2f2;
  //  .other {
  //    text-align: center;
  //    margin-top: 205px;
  //    font-weight: bold;
  //    font-size: 14px;
  //  }
  //}
  //&-box {
  //  width: 160px;
  //  height: 100%;
  //  text-align: left;
  //  outline: 0.1px solid #c7d2f2;
  //}
  //&-info {
  //  margin-top: 15px;
  //  height: 200px;
  //  border-left: 5px solid #1f62c5;
  //  background-color: #dce5ff;
  //  padding: 6px;
  //  .content1 {
  //    font-weight: bold;
  //    font-size: 14px;
  //  }
  //  .content2 {
  //    font-size: 12px;
  //  }
  //}
  //&-column {
  //  width: 100px;
  //  height: 60px;
  //  color: #1f62c5;
  //  outline: 0.1px solid #c7d2f2;
  //}
  //&-column1 {
  //  width: 100px;
  //  height: 50px;
  //  color: #333333;
  //  outline: 0.1px solid #c7d2f2;
  //}
}
</style>
